import * as z from 'zod';

// Types
import { MediaZod } from '@/types/MediaType';
import { CTAZod } from '@/types/CTAType';
import { TitleZod } from '@/types/TitleType';
import { WaveWrapperZod } from '@/types/WaveWrapperType';
import { ParagraphZod } from '@/components/atoms/Paragraph/ParagraphType';
import { BubbleStyleZod } from '@/types/BubbleStyleType';
import { ClientPageRelationZod } from '@/types/ClientPageRelationType';

const CustomerCaseItemZod = z.object({
  id: z.number(),
  picture: MediaZod.nullable().optional(),
  title: TitleZod.nullable().optional(),
  paragraph: ParagraphZod.nullable().optional(),
  link: z.string().nullable().optional(),
  bubbleStyle: BubbleStyleZod,
  clientPage: ClientPageRelationZod.nullable().optional(),
});

const CustomerCasesZod = z.object({
  __component: z.literal('block.customer-cases'),
  id: z.number(),
  title: TitleZod,
  cta: CTAZod.nullable(),
  cases: z.array(CustomerCaseItemZod),
  waveWrapper: WaveWrapperZod.nullable(),
});

export { CustomerCasesZod, CustomerCaseItemZod };
export type CustomerCasesType = z.infer<typeof CustomerCasesZod>;
export type CustomerCaseItemType = z.infer<typeof CustomerCaseItemZod>;
